<template>
  <section class="video-section" id="video">
    <div class="container">
      <div class="video-header">
        <div class="source-tag">{{ t('video.tag') }}</div>
        <h2 class="serif">{{ t('video.title') }}</h2>
        <p>{{ t('video.subtitle') }}</p>
      </div>

      <div class="video-wrapper">
        <a class="video-poster" :style="{ backgroundImage: 'url(' + publicPath + 'video.jpg)' }" href="https://radar.avrotros.nl/artikel/fragment-banken-innen-onnodige-hypotheekrente-61102" target="_blank" rel="noopener">
          <div class="play-btn"></div>
        </a>
      </div>

      <p class="video-credit" v-html="t('video.credit')"></p>
    </div>
  </section>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()
const publicPath = process.env.BASE_URL || '/'
</script>

<style scoped>
.video-section {
  background: var(--bg-warm);
  padding: 80px 0;
  scroll-margin-top: 20px;
  border-top: 1px solid var(--line-soft);
  border-bottom: 1px solid var(--line-soft);
}
@media (max-width: 768px) {
  .video-section { padding: 48px 0; }
}
.video-header {
  text-align: center;
  margin-bottom: 40px;
}
.video-header .source-tag {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--ink);
  color: var(--bg);
  padding: 8px 18px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 28px;
}
.video-header .source-tag::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--blue);
  animation: rec 2s ease-in-out infinite;
}
.video-header h2 {
  font-size: clamp(36px, 5.5vw, 56px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
  margin-bottom: 16px;
  max-width: 22ch;
  margin-left: auto;
  margin-right: auto;
}
.video-header p {
  font-size: 17px;
  color: var(--ink-soft);
  max-width: 78ch;
  margin: 0 auto;
}

.video-wrapper {
  max-width: 880px;
  margin: 0 auto;
  border: none;
  border-radius: 24px;
  box-shadow: var(--shadow-soft);
  background: var(--bg-deep);
  position: relative;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}
.video-poster {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
}
.video-poster::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  transition: background 0.3s;
}
.video-poster:hover::before {
  background: rgba(0, 0, 0, 0.15);
}
.video-poster .play-btn {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: float 3s ease-in-out infinite;
}
.video-poster:hover .play-btn {
  transform: scale(1.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.video-poster .play-btn::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 22px solid var(--ink);
  border-top: 13px solid transparent;
  border-bottom: 13px solid transparent;
  margin-left: 4px;
}

.video-credit {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: var(--ink-muted);
}
.video-credit :deep(a) {
  color: var(--ink);
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: var(--blue);
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}
</style>
